import { CloudLightningIcon, CloudRainIcon, GaugeIcon, GlobeIcon, ThermometerSunIcon, WindIcon } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

export type Module = {
  number: string;
  title: string;
  summary: string;
  icon: LucideIcon;
};

export const modules: Module[] = [
  {
    number: '1',
    title: "Fondamenti di Meteorologia e Scienze dell'Atmosfera",
    summary: "Che cos'è la meteorologia, composizione e strati dell'atmosfera, le variabili del tempo, pressione, umidità, punto di rugiada, tempo e clima.",
    icon: GlobeIcon,
  },
  {
    number: '2',
    title: "Energia, Temperatura e Termodinamica dell'Atmosfera",
    summary: "Radiazione solare, bilancio energetico, stagioni, temperatura dell'aria, gradiente termico, stabilità e instabilità dell'aria.",
    icon: ThermometerSunIcon,
  },
  {
    number: '3',
    title: 'Nubi, Precipitazioni e Umidità Atmosferica',
    summary: "Vapore acqueo e umidità, condensazione, classificazione delle nubi, nebbia, pioggia, neve e grandine, ciclo dell'acqua.",
    icon: CloudRainIcon,
  },
  {
    number: '4',
    title: "Circolazione Atmosferica, Masse d'Aria e Sistemi Meteorologici",
    summary: "Gradiente di pressione e vento, circolazione generale, masse d'aria, fronti, anticicloni e cicloni, lettura delle carte meteo.",
    icon: WindIcon,
  },
  {
    number: '5',
    title: 'Maltempo Severo ed Eventi Atmosferici Estremi',
    summary: "Temporali e supercelle, fulmini, grandine, trombe d'aria, alluvioni lampo, ondate di calore, uragani e sicurezza.",
    icon: CloudLightningIcon,
  },
  {
    number: '6',
    title: 'Osservazione Meteorologica, Strumenti e Dati Meteo',
    summary: 'Stazione meteorologica, termometro, barometro, igrometro, anemometro e pluviometro, satelliti e radar, registrazione e analisi dei dati.',
    icon: GaugeIcon,
  },
];
